import { useCustomerContext } from 'pages/Customer/CustomerContext';
import { Contract } from 'shared/models/contract';
import ContractDataBox from './ContractDataBox';
import ContractDetailsBlock from './ContractDetailsBlock';
import PaymentMethodActionsMenu from './PaymentMethodActionsMenu';
interface ContractPaymentMethodSectionProps {
  loading?: boolean;
  contract: Contract;
}
const ContractPaymentMethodSection = ({
  loading,
  contract,
}: ContractPaymentMethodSectionProps) => {
  const {
    customer: { cards },
  } = useCustomerContext();

  const defaultCard = cards?.find((card) => card.isDefault);

  return (
    <ContractDetailsBlock
      rightElement={
        <PaymentMethodActionsMenu loading={loading} contract={contract} />
      }
      title="Método de pagamento"
      loading={loading}
    >
      <ContractDataBox loading={loading} label="Método">
        {contract.paymentMethodName}
        {contract.isCreditCard && defaultCard && (
          <>
            <br />
            {defaultCard.brand} - {defaultCard.maskedNumber} -{' '}
            {defaultCard.expirationDate}
          </>
        )}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Última alteração do método">
        {contract.updated_bank_id_at !== undefined
          ? contract.updated_bank_id_at
              .clone()
              .subtract(28, 'days')
              .format('DD/MM/YYYY')
          : '-'}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Número de parcelas">
        {contract.installmentsNumber && contract.installmentsNumber > 0
          ? contract.installmentsNumber
          : '-'}
      </ContractDataBox>
      <ContractDataBox loading={loading} label="Data de vencimento">
        {contract.due_date?.format('DD')}
      </ContractDataBox>
    </ContractDetailsBlock>
  );
};
export default ContractPaymentMethodSection;
